/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeV2 } from '@insticator/insticator-ui';
import { aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- PAGE HEADER : STYLES --------------- ++++++++++ */
export default {
	pageheader: {
        paddingBottom: '32px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        opacity: '0',
        animationName: 'fadeInUp',
        animationDuration: aniSpeed,
        animationFillMode: 'forwards',
        '& .title': {
            margin: 0,
            '& h2': {
                fontSize: pxToEm(36),
                fontWeight: 500,
                marginBottom: 0,
                display: 'flex',
                alignItems: 'center',
                '& .breadcrumb': {
                    display: 'flex',
                    alignItems: 'baseline',
                    '& .icon': {
                        fontSize: '70%',
                        color: themeV2.color.base.gray.dark,
                        margin: replacePXinStringWithEM('0 20px'),
                        opacity: '0',
                        animationName: 'fadeInLeft',
                        animationDuration: aniSpeed,
                        animationFillMode: 'forwards',
                        animationDelay: '.4s'
                    },
                    '& .subtitle': {
                        // fontFamily: 'WorkSans-Regular',
                        fontSize: '85%',
                        fontWeight: 'normal',
                        opacity: '0',
                        animationName: 'fadeInLeft',
                        animationDuration: aniSpeed,
                        animationFillMode: 'forwards',
                        animationDelay: '.35s'
                    }
                }
            }
        },
        '& .tip': {
            alignSelf: 'center'
        },
        '& .name-dataAlertBannerBeta': {
            maxWidth: '35%',
        }
	}
}; 